import script from "./TaskPrint.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskPrint.vue?vue&type=script&setup=true&lang=js"

import "./TaskPrint.vue?vue&type=style&index=0&id=420d9360&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-420d9360"]])

export default __exports__